
const getters = {
  money () {
    return { precision: 2, decimal: ',', thousands: '.', prefix: '', suffix: '', masked: false }
  }
}

export const helper = {
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/helper.module.js